import ArrowLeftLong from '@ixigo/icons/long-arrow-left';
import { IconButton } from '@ixigo/iui/icon-button';
import { Text } from '@ixigo/iui/text';
import { TopNavBar } from '@/components/top-nav-bar/top-nav-bar';

const CARD_ASPECT = 210 / 335;

function Bone({ className }: { className?: string }) {
	return (
		<div className={`animate-pulse rounded-md bg-tertiary ${className}`} />
	);
}

function CardBone({ className }: { className?: string }) {
	return (
		<div className={`animate-pulse rounded-md bg-secondary ${className}`} />
	);
}

function CardSkeleton() {
	return (
		<div
			className="relative w-full rounded-2xl overflow-hidden bg-primary"
			style={{
				paddingTop: `${CARD_ASPECT * 100}%`,
			}}
		>
			<div className="absolute inset-0 flex flex-col justify-between p-xl">
				<div className="flex justify-between items-start">
					<CardBone className="h-5 w-16 rounded-sm" />
					<CardBone className="h-6 w-10 rounded-sm" />
				</div>

				<div className="flex flex-col gap-md">
					<CardBone className="h-7 w-8 rounded-sm" />
					<CardBone className="h-4 w-44 mt-7" />
					<CardBone className="h-3 w-24" />
				</div>
			</div>
		</div>
	);
}

function AddCardRowSkeleton() {
	return (
		<div className="flex items-center gap-3 p-xl bg-level2 rounded-xl mt-6">
			<Bone className="h-10 w-10 shrink-0 rounded-md" />
			<div className="flex flex-col gap-1">
				<Bone className="h-4 w-20" />
				<Bone className="h-3 w-36" />
			</div>
		</div>
	);
}

function MoreOptionRowSkeleton() {
	return (
		<div className="flex items-center gap-lg py-xl">
			<Bone className="h-10 w-10 shrink-0 rounded-md" />
			<div className="flex flex-1 flex-col gap-sm">
				<Bone className="h-4 w-24" />
				<Bone className="h-3 w-32" />
			</div>
			<Bone className="h-4 w-8 shrink-0" />
		</div>
	);
}

export function ManagePaymentsSkeleton() {
	return (
		<div className="mx-auto w-full max-w-md min-h-full bg-secondary">
			<TopNavBar
				className="sticky top-0 bg-secondary z-10"
				leftSlot={
					<IconButton
						variant="text"
						size="md"
						className="ring-glass glass-soft"
						onClick={() => window.history.back()}
					>
						<ArrowLeftLong className="text-primary" />
					</IconButton>
				}
			>
				<Text variant="heading-xs" fontWeight="bold" fontFamily="serif">
					Manage Payment Options
				</Text>
			</TopNavBar>

			<div className="flex flex-col gap-xl p-xl pt-3xl">
				{/* Saved card deck */}
				<CardSkeleton />

				{/* Add Card row */}
				<AddCardRowSkeleton />

				{/* More Options section */}
				<div className="bg-level2 rounded-xl px-xl pt-xl">
					<Bone className="h-3 w-28" />

					<MoreOptionRowSkeleton />

					<div className="border-t border-solid border-tertiary">
						<MoreOptionRowSkeleton />
					</div>
				</div>
			</div>
		</div>
	);
}
